import { getDynamicPTS } from '../../../api/api';
import { CONTENT_WIDTH, bottomMarginItemGlobal } from '../../utils/pdfConstants';

const YEAR_KEYS = ['y1','y2','y3','y4','y5','y6','y7','y8','y9','y10','y11'];

function getKLColor(kl) {
  switch (kl) {
    case 'KL1': case 'KL2': return '#ba3b46';
    case 'KL3': return '#d0c407';
    case 'KL4': case 'KL5': return '#04aa00';
    default: return 'black';
  }
}

function renderCellValue(v) {
  if (v === 0 || v === null || v === undefined || v === '' || v === '0') return '';
  return String(v);
}

export async function renderDynamicPTSBlock({ data: blockData, content, contentWidth = CONTENT_WIDTH, linkedProjectId = null }) {
  const projectId = linkedProjectId ?? blockData?.projectId;
  if (!projectId) return;

  let ptsData;
  try {
    const res = await getDynamicPTS(projectId);
    ptsData = res.data;
  } catch (e) {
    console.warn('[RenderDynamicPTSBlock] failed to fetch PTS data:', e);
    return;
  }

  const sections = ptsData?.sections ?? [];
  if (sections.length === 0) return;

  const baseYear = ptsData?.year ?? new Date().getFullYear();
  const numYears = 11;
  const years = Array.from({ length: numYears }, (_, i) => baseYear + i);
  const projectName = ptsData?.name ?? 'PTS';

  const fontSize = 9;
  const smallFontSize = fontSize * 0.85;
  const yearsFontSize = fontSize * 0.75;
  const firstColW = 155;
  const klColW = 24;
  const cellPadH = 4;
  const yearW = (contentWidth - firstColW - klColW - (2 + years.length) * cellPadH * 2) / years.length;

  const rows = [];

  // Super-header
  rows.push([
    { text: '', colSpan: 2, fillColor: '#04aa00' }, {},
    {
      text: `Kustannusarvio (x 1000€) Kustannustaso ${baseYear} sis. Alv 25,5%`,
      colSpan: years.length,
      alignment: 'right',
      bold: true,
      font: 'Lato',
      fontSize: smallFontSize,
      color: 'white',
      fillColor: '#04aa00',
      margin: [0, 2, 4, 2],
    },
    ...Array(years.length - 1).fill({}),
  ]);

  // Year header
  rows.push([
    { text: projectName, style: 'tableHeader', colSpan: 2, bold: true, alignment: 'left', font: 'Lato', fontSize: smallFontSize, fillColor: '#04aa00', color: 'white' },
    {},
    ...years.map(y => ({
      text: String(y),
      style: 'tableHeader',
      alignment: 'center',
      fillColor: '#04aa00',
      color: 'white',
      bold: true,
      font: 'Lato',
      fontSize: yearsFontSize,
    })),
  ]);

  // Year totals per column (for footer)
  const yearTotals = Array(numYears).fill(0);

  sections.forEach(section => {
    const kl = section.kl_rating || 'KL3';
    const entries = section.entries ?? [];

    // Section header row
    rows.push([
      { text: section.name, bold: true, fillColor: '#f0f0f0', font: 'Lato', fontSize: smallFontSize, noWrap: false },
      { text: kl, alignment: 'center', bold: true, color: getKLColor(kl), font: 'Lato', fillColor: '#f0f0f0', fontSize: smallFontSize },
      ...years.map(() => ({ text: '', fillColor: '#f0f0f0', font: 'Lato', fontSize: smallFontSize })),
    ]);

    // Entry rows
    entries.forEach(entry => {
      const label = (entry.label || '').trim();
      if (label.length < 2) return;

      const values = YEAR_KEYS.map(k => entry[k] ?? '');
      values.forEach((v, i) => {
        const n = parseFloat(v);
        if (!isNaN(n)) yearTotals[i] += n;
      });

      rows.push([
        { text: label, alignment: 'left', font: 'Lato', fontSize: smallFontSize, noWrap: false, margin: [6, 0, 0, 0] },
        { text: '', fontSize: smallFontSize },
        ...values.map(v => ({
          text: renderCellValue(v),
          alignment: 'center',
          font: 'Lato',
          fontSize: smallFontSize,
        })),
      ]);
    });
  });

  // Totals footer
  rows.push([
    { text: 'YHTEENSÄ', bold: true, color: 'white', fillColor: '#04aa00', alignment: 'left', font: 'Lato', fontSize: smallFontSize },
    { text: '', fillColor: '#04aa00' },
    ...yearTotals.map(v => ({
      text: v === 0 ? '' : String(Math.round(v)),
      bold: true,
      color: 'white',
      fillColor: '#04aa00',
      alignment: 'center',
      font: 'Lato',
      fontSize: smallFontSize,
    })),
  ]);

 content.push({
  table: {
    widths: [firstColW, klColW, ...Array(years.length).fill(yearW)],
    body: rows,
  },
  layout: {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => cellPadH,
    paddingRight: () => cellPadH,
    paddingTop: () => 3,
    paddingBottom: () => 3,
  },
  margin: [0, 0, 0, bottomMarginItemGlobal],

  // Keep the whole PTS table on the same page when possible.
  // pdfMake moves it to the next page only if the entire table
  // doesn't fit in the remaining space.
  unbreakable: true,
});
}
